import type { SelectOption } from '@/shared/types/options';

/**
 * Marques proposées en pré-remplissage tant que la frappe fait moins de deux caractères.
 *
 * ⚠️ Liste ÉDITORIALE, pas de la donnée : elle reste en dur volontairement. La sortir en base
 * demanderait un critère de popularité qui n'existe pas, pour un gain nul — elle ne pèse rien et ne
 * périme pas au sens du catalogue.
 */
export const POPULAR_BRANDS: SelectOption[] = [
  { label: 'Nike', value: '53' },
  { label: 'Adidas', value: '14' },
  { label: 'Zara', value: '12' },
  { label: 'H&M', value: '7' },
  { label: 'Louis Vuitton', value: '417' },
  { label: 'Gucci', value: '567' },
  { label: 'Prada', value: '3573' },
  { label: 'Chanel', value: '362' },
  { label: 'Hermès', value: '614' },
  { label: 'Lacoste', value: '304' },
  { label: 'Ralph Lauren', value: '88' },
  { label: 'Tommy Hilfiger', value: '94' },
  { label: 'Calvin Klein', value: '255' },
  { label: "Levi's", value: '9' },
  { label: 'The North Face', value: '2319' },
  { label: 'Patagonia', value: '2324' },
  { label: 'Supreme', value: '14969' },
  { label: 'Stone Island', value: '2251' },
  { label: 'Moncler', value: '6539' },
  { label: 'Canada Goose', value: '6536' },
  { label: 'Burberry', value: '64' },
  { label: 'Balenciaga', value: '1594' },
  { label: 'Versace', value: '645' },
  { label: 'Dior', value: '399' },
  { label: 'Fendi', value: '482' },
  { label: 'Yves Saint Laurent', value: '770' },
  { label: 'Valentino', value: '2197' },
  { label: 'Givenchy', value: '1063' },
  { label: 'Armani', value: '554' },
  { label: 'Hugo Boss', value: '26' },
];
